export default __webpack_public_path__ + "static/media/mark-black.bbd7169d.svg";